import { AnyAction } from 'redux';
import actionTypes from '../types/idCardTypes';

const initialState = {
  token: '',
  transactionId: '',
  idCardInfo: '',
  certificate: '',
  userInfo: {},
  downLoadIdCardInfo: {},
  callback: (): any => {},
};

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.TRANSACTION_ID:
      return {
        ...state,
        transactionId: action.payload,
      };
    case actionTypes.TOKEN:
      return {
        ...state,
        token: action.payload,
      };
      case actionTypes.ID_CARD_INFO:
        return{
          ...state,
          idCardInfo: action.payload,
        };
        case actionTypes.USER_INFO:
        return{
          ...state,
          userInfo: action.payload,
        };
        case actionTypes.DOWNLOAD_IDCARD_INFO:
          return{
            ...state,
            downLoadIdCardInfo: action.payload,
          };
        case actionTypes.CERIFICATE:
        return{
          ...state,
          certificate: action.payload,
        };
        case actionTypes.SET_CALLBACK:
          return {
            ...state,
            callback: action.payload,
          };
          case actionTypes.RESET_ID_CARD_STATE:
            return {
              ...initialState,
            };
    default: return state;
  }
};

export { reducer as IdCardReducer };
